"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetProductBoxPlacement = exports.VALID_PLACEMENTS = void 0;
var _analyticsData = require("@ori/analytics-data");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _constants = require("../components/BannerProductListing/constants");
const VALID_PLACEMENTS = exports.VALID_PLACEMENTS = new Set([
    _analyticsData.Placement.Typeform,
    _analyticsData.Placement.Revieve,
    _analyticsData.Placement.RevieveFoundationFinder,
    _analyticsData.Placement.RevieveSkinDiagnosis,
    _analyticsData.Placement.RevieveVirtualTryOn,
    _analyticsData.Placement.RevieveVirtualTryOnPDP
]);
const validatePlacement = (placement)=>{
    if (placement != null && VALID_PLACEMENTS.has(placement)) {
        return placement;
    }
    return _analyticsData.Placement.ProductListing;
};
const useGetProductBoxPlacement = ()=>{
    // TODO -- use validate prop when it will be suitable for enums
    const placementParam = (0, _presentationUtils.getTypedQueryParam)({
        name: _constants.ORIGIN_QUERY_KEY,
        fallback: _analyticsData.Placement.ProductListing
    });
    return (0, _react.useMemo)(()=>validatePlacement(placementParam), [
        placementParam
    ]);
};
exports.useGetProductBoxPlacement = useGetProductBoxPlacement;
